import { formatters } from "@fraction/shared";
import _ from "lodash";
import type { ChecklistApp } from "src/api/fraction";

/**
 * A deal as the command palette, its recents and the deal picker render it.
 * Lives outside the search hook so the local index and recents can build the
 * same shape without importing the hook that consumes them.
 */
export interface DisplayApp {
  id: string;
  eid?: string;
  applicantNames: string;
  brokerNames: string;
  brokerEmails: string[];
  address: string;
  status?: string;
  syntheticStatus?: string;
  /** The funded loan's status ("Payout Requested", "Paid Out"), when the deal has one. */
  loanStatus?: string;
}

export function toDisplayApp(app: ChecklistApp): DisplayApp {
  return {
    id: app.id,
    eid: app.eid,
    applicantNames: formatters.application.applicantNames(app) || "",
    brokerNames:
      app.brokers?.map((b: any) => formatters.user.userName(b.user) || b.user?.email || "").join(", ") || "",
    brokerEmails: app.brokers?.map((b: any) => b.user?.email).filter(Boolean) || [],
    address: formatters.property.shortFormattedAddress(app.property) || "",
    status: app.syntheticStatus ? formatters.enums.APPLICATION_STATUS_MAP[app.syntheticStatus] : undefined,
    syntheticStatus: app.syntheticStatus,
    loanStatus: app.loan?.status ? _.startCase(app.loan.status) : undefined,
  };
}
